export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15097.bb8864ab.jpg";